import axios from 'axios';
import { config } from '../config';

const api = axios.create({
  baseURL: config.apiUrl,
  timeout: 15000, // 15 s — prevents infinite spinner on slow connections
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

// Global response interceptor — normalise errors into a consistent shape
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.code === 'ECONNABORTED' || err.message?.includes('timeout')) {
      return Promise.reject(new Error('সংযোগ ধীর। আবার চেষ্টা করুন।'));
    }
    if (!err.response) {
      return Promise.reject(new Error('নেটওয়ার্ক সমস্যা। ইন্টারনেট সংযোগ পরীক্ষা করুন।'));
    }
    return Promise.reject(err);
  }
);

export default api;
